import SubHeader from "./fragments/SubHeader";
import UserListTable from "./fragments/UserListTable";
import RightGuard from "../../guards/RightGuard";

export default function UserManagement() {

    return (
        <main>
            <RightGuard canPass={true}>
                <SubHeader/>
                <UserListTable/>
            </RightGuard>
        </main>
    )
}